mutation TrackAiAssistantConversation($input: AiAssistantConversation!) {
    trackAiAssistantConversation(input: $input) {
        success
    }
}
